const setup = (i, s, o, g, r, a, m) => {
  i['GoogleAnalyticsObject'] = r
  i[r] = i[r] || ((...args) => {
    (i[r].q = i[r].q || []).push(args)
  })
  i[r].l = 1 * new Date()
  a = s.createElement(o)
  m = s.getElementsByTagName(o)[0]
  a.async = 1
  a.src = g
  m.parentNode.insertBefore(a, m)
}

const send = (...args) => {
  window.ga && window.ga('send', ...args)
}

export const initializeAnalytics = (trackingId) => {
  if (!trackingId) {
    throw new Error('No Google analytics tracking ID.')
  }
  setup(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
  window.ga && window.ga('create', trackingId, 'auto')
}

export const sendAnalyticsPageview = () => {
  send('pageview')
}

export const sendAnalyticsEvent = (category, action, label, value) => {
  send('event', category, action, label, value)
}
